<div
  [cbPopover]="Timer"
  [showArrow]="false"
  (popoverOpen)="setStartValue()"
  (popoverClose)="onTouchedCallback()"
  [matchParentWidth]="false"
  class="cb-timepicker-wrapper"
  [class.cb-disabled]="disabled()"
  [class.cb-required]="required()"
  [class.cb-error]="error()"
>
  @if (label() || info()) {
  <div class="cb-timepicker-label">
    @if (label()) {
    <label>{{ label() }}</label>
    } @if (info() && info()!.length > 0) {
    <cb-icon
      [cbTooltip]="info()!"
      tooltipPosition="top"
      tooltipStyle="dark"
      name="cb-base-outline-help"
    ></cb-icon>
    }
  </div>
  }
  <div class="cb-timepicker-container">
    <div class="cb-timepicker" [class.cb-reset]="canReset">
      @if (icon()) {
      <div #Prefix class="cb-timepicker-prefix">
        @if (icon()) {
        <cb-icon [name]="icon()"></cb-icon>
        }
      </div>
      }

      <div
        class="cb-timepicker-value"
        [attr.tabindex]="disabled() ? undefined : 0"
      >
        @if (strValue && value) {
        <span>{{ strValue }}</span>
        } @else {
        <span class="cb-timepicker-placeholder">{{ placeholder() }}</span>
        }
      </div>

      @if (canReset) {
      <div
        class="cb-timepicker-reset-button-container"
        (click)="reset(); $event.stopImmediatePropagation()"
      >
        <div class="cb-timepicker-reset-button">
          <cb-icon name="cb-base-outline-close"></cb-icon>
        </div>
      </div>
      }
    </div>
  </div>
  @if (hint() && hint()!.length > 0) {
  <p class="cb-timepicker-hint">{{ hint()! }}</p>
  }
</div>

<ng-template #Timer>
  <div class="cb-timer-container">
    @if (value) {
    <div class="cb-timer-col">
      <div class="cb-timer-button" (click)="increment('hour')">
        <cb-icon name="cb-base-outline-chevronup"></cb-icon>
      </div>
      <div class="cb-input-wrapper">
        <div class="cb-input-container">
          <div class="cb-input">
            <input
              tabindex="2"
              (focus)="selectAll($event)"
              type="number"
              [max]="23"
              [min]="0"
              [step]="step()"
              [disabled]="disabled()"
              [placeholder]="'00'"
              [(ngModel)]="value.hour"
              (input)="onUserInput($event, 'hour')"
              (ngModelChange)="validateTime('hour', value.hour)"
              maxlength="2"
            />
          </div>
        </div>
      </div>
      <div class="cb-timer-button" (click)="decrement('hour')">
        <cb-icon name="cb-base-outline-chevrondown"></cb-icon>
      </div>
    </div>
    <p>:</p>
    <div class="cb-timer-col">
      <div class="cb-timer-button" (click)="increment('minute')">
        <cb-icon name="cb-base-outline-chevronup"></cb-icon>
      </div>
      <div class="cb-input-wrapper">
        <div class="cb-input-container">
          <div class="cb-input">
            <input
              tabindex="2"
              type="number"
              [max]="59"
              [min]="0"
              (focus)="selectAll($event)"
              [step]="step()"
              [disabled]="disabled()"
              [placeholder]="'00'"
              [(ngModel)]="value.minute"
              (input)="onUserInput($event, 'minute')"
              (ngModelChange)="validateTime('minute', value.minute)"
              maxlength="2"
            />
          </div>
        </div>
      </div>
      <div class="cb-timer-button" (click)="decrement('minute')">
        <cb-icon name="cb-base-outline-chevrondown"></cb-icon>
      </div>
    </div>
    @if (hasSeconds() && value.second !== undefined) {
    <p>:</p>
    <div class="cb-timer-col">
      <div class="cb-timer-button" (click)="increment('second')">
        <cb-icon name="cb-base-outline-chevronup"></cb-icon>
      </div>
      <div class="cb-input-wrapper">
        <div class="cb-input-container">
          <div class="cb-input">
            <input
              (focus)="selectAll($event)"
              type="number"
              [max]="59"
              [min]="0"
              [step]="step()"
              [disabled]="disabled()"
              [placeholder]="'00'"
              [(ngModel)]="value.second"
              (input)="onUserInput($event, 'second')"
              (ngModelChange)="validateTime('second', value.second)"
              maxlength="2"
            />
          </div>
        </div>
      </div>
      <div class="cb-timer-button" (click)="decrement('second')">
        <cb-icon name="cb-base-outline-chevrondown"></cb-icon>
      </div>
    </div>
    } }
  </div>
</ng-template>
